module.exports = "<lfwms-searchable-entity-search [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-search>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-search/reports-configuration-search.component.html
// module id = ../../../../../src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-search/reports-configuration-search.component.html
// module chunks = main